/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */
import { FETCHING_ORGANIZATIONS, FETCHED_ORGANIZATIONS, FETCHING_ORGANIZATIONS_ERROR } from '../actions/actionTypes';

const organizationsInit = {
  error: null,
  items: null,
  isFetching: false
};

const organizationsReducer = (state = organizationsInit, action) => {
  switch (action.type) {
    case FETCHING_ORGANIZATIONS:
      return Object.assign({}, state, { error: null, isFetching: true, items: null });
    case FETCHING_ORGANIZATIONS_ERROR:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case FETCHED_ORGANIZATIONS:
      return Object.assign({}, state, { error: null, isFetching: false, items: action.payload });
    default:
      return state;
  }
};

export default organizationsReducer;
